import clsx from "clsx";
import React from "react";
import { FeedHeader } from "web/react/components/feed-header/feed-header";
import withReduxProvider from "web/react/redux-provider";
import styles from "./pre-sale-landing-shop-page.module.css";

interface PreSaleLandingShopPageProps {
    title: string;
    description: string;
}

function PreSaleLandingShopPage({ title, description }: PreSaleLandingShopPageProps): JSX.Element {
    return (
        <>
            <FeedHeader title={title} />
            <div className={clsx(styles.descriptionContainer)}>{description}</div>
        </>
    );
}

export default withReduxProvider(PreSaleLandingShopPage);
